export const collaboratorRole = [
  'adv',
  'adv-distanciel',
  'responsable-magasin',
  'chef-secteur',
] as const
export type CollaboratorRole = (typeof collaboratorRole)[number]

export const collaboratorRoleLabel: Record<CollaboratorRole, string> = {
  adv: 'Animateur des Ventes',
  'adv-distanciel': 'Animateur des Ventes - Distanciel',
  'responsable-magasin': 'Manager de Boutiques',
  'chef-secteur': 'Responsable de Secteur',
}
